/* eslint-disable import/no-unresolved */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-array-index-key */
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { useContext, useEffect } from "react";
import Header from "layout/header";
// import { useLogin } from "services/auth-api";
import Dashboard from "../pages/dashboard";
import UsersFollowUp from "../pages/users/follow-up";
import AddUser from "../pages/users/add-user";
import RolesFollowUp from "../pages/roles/follow-up";
import AddRole from "../pages/roles/add-role";
import UserDetails from "../pages/users/user-details";
import CustomersFollowUp from "../pages/customers/follow-up";
import AddCustomer from "../pages/customers/addCustomer";
import CustomerDetails from "../pages/customers/customer-details";
import AddAssets from "../pages/assests/add-assets";
import AssetsList from "../pages/assests/assets-list";
import LocationsList from "../pages/servicePoints/locations-list";
import StockList from "../pages/stock/stock-list";
import AddStock from "../pages/stock/add-stock";
import CashCenterList from "../pages/cashCenter/cash-center-list";
import ConsumablesList from "../pages/consumables/consumables-list";
import AddConsumable from "../pages/consumables/add-consumable";
import EditCustomer from "../pages/customers/edit-customer";
import AddCashCenter from "../pages/cashCenter/addCashCenter";
import AuthContext from "../store/auth-context";
import CashCenterDetailsView from "../pages/cashCenter/cash-center-details";
import EditCashCenter from "../pages/cashCenter/edit-cash-center";
import TicketsList from "../pages/procare/tickets/tickets-list";
import Profile from "../pages/profile";
import ChangePassword from "../pages/changePassword";
import AddServicePoint from "../pages/servicePoints/add-service-point";
import VehiclesList from "../pages/vehicles/follow-up";
import AddVehicle from "../pages/vehicles/add-vehicle";
import UpdateVehicle from "../pages/vehicles/edit-vehicle";
import RoleDetails from "../pages/roles/role-details";
import VehicleDetails from "../pages/vehicles/vehicle-details";
import ServicePointDetailsView from "../pages/servicePoints/locations-details";
import EditServicePoint from "../pages/servicePoints/edit-service-point";
import EditStock from "../pages/stock/edit-stock";
import StockDetails from "../pages/stock/stock-details";
import AddStockBulk from "../pages/stock/add-stock-bulk";
import ConsumableSummary from "../pages/consumables/consumable-summary";
import ConsumableDetails from "../pages/consumables/consumable-details";
import EditConsumable from "../pages/consumables/edit-consumable";
import RoutesList from "../pages/routesManagement";
import RouteListener from "../components/routeListener";
import EditCurrency from "../pages/currencies/edit-currency";
import CurrencyDetails from "../pages/currencies/currency-details";
import CurrencyList from "../pages/currencies/currency-list";
import AddCurrency from "../pages/currencies/add-currency";
import { Paths } from "./paths";
import NotificationList from "../pages/notifications/notification-list";
import AddNotification from "../pages/notifications/add-notification";
import NotificationDetails from "../pages/notifications/notifications-details";
import EditNotification from "../pages/notifications/edit-notification";
import EscalationMatrixList from "../pages/escalationMatrix/escalation-matrix-list";
import AddEscalationMatrix from "../pages/escalationMatrix/add-escalation-matrix";
import EditEscalationMatrix from "pages/escalationMatrix/edit-escalation-matrix";
import AddRoute from "pages/routesManagement/add-route";
import LicenseExpiryToast from "components/warning-toast";
import IdleManager from "components/IdleManager";
import LoginAgreement from "pages/verification/login-agreement";

const routes = [
  {
    path: Paths.dashboard,
    element: <Dashboard />,
    isPrivate: 1,
  },
  {
    path: "*",
    element: <Dashboard />,
    isPrivate: 1,
  },

  {
    permission: "user-view",
    path: Paths.users,
    element: <UsersFollowUp />,
    isPrivate: 1,
  },
  {
    permission: "user-add",
    path: Paths.addUser,
    element: <AddUser />,
    isPrivate: 1,
  },
  {
    path: Paths.roles,
    element: <RolesFollowUp />,
    isPrivate: 1,
  },
  {
    path: Paths.addRole,
    element: <AddRole />,
    isPrivate: 1,
  },
  {
    path: `${Paths.roleDetails}/:roleName`,
    element: <RoleDetails />,
    isPrivate: 1,
  },
  {
    path: `${Paths.editRole}/:roleName`,
    element: <AddRole />,
    isPrivate: 1,
  },

  {
    path: `${Paths.editUser}/:userId`,
    element: <AddUser />,
    isPrivate: 1,
  },
  {
    path: `${Paths.userDetails}/:userId`,
    element: <UserDetails />,
    isPrivate: 1,
  },

  {
    path: Paths.addCustomer,
    element: <AddCustomer />,
    isPrivate: 1,
  },
  {
    path: `${Paths.editCustomer}/:customerId`,
    element: <EditCustomer />,
    isPrivate: 1,
  },
  {
    path: Paths.customers,
    element: <CustomersFollowUp />,
    isPrivate: 1,
  },
  {
    path: `${Paths.customerDetails}/:customerId`,
    element: <CustomerDetails />,
    isPrivate: 1,
  },
  {
    path: Paths.assets,
    element: <AssetsList />,
    isPrivate: 1,
  },
  {
    path: Paths.addAssets,
    element: <AddAssets />,
    isPrivate: 1,
  },
  {
    path: Paths.locations,
    element: <LocationsList />,
    isPrivate: 1,
  },
  {
    path: Paths.addLocations,
    element: <AddServicePoint />,
    isPrivate: 1,
  },
  {
    path: `${Paths.editLocations}/:locationId`,
    element: <EditServicePoint />,
    isPrivate: 1,
  },
  {
    path: `${Paths.locationDetails}/:locationId`,
    element: <ServicePointDetailsView />,
    isPrivate: 1,
  },
  {
    path: Paths.stock,
    element: <StockList />,
    isPrivate: 1,
  },
  {
    path: Paths.addStock,
    element: <AddStock />,
    isPrivate: 1,
  },
  {
    path: Paths.addStockBulk,
    element: <AddStockBulk />,
    isPrivate: 1,
  },
  {
    path: `${Paths.editStock}/:stockId`,
    element: <EditStock />,
    isPrivate: 1,
  },
  {
    path: `${Paths.stockDetails}/:stockId`,
    element: <StockDetails />,
    isPrivate: 1,
  },
  {
    path: Paths.cashCenter,
    element: <CashCenterList />,
    isPrivate: 1,
  },
  {
    path: `${Paths.cashCenterDetails}/:cashCenterId`,
    element: <CashCenterDetailsView />,
    isPrivate: 1,
  },
  {
    path: Paths.addCashCenter,
    element: <AddCashCenter />,
    isPrivate: 1,
  },
  {
    path: `${Paths.editCashCenter}/:cashCenterId`,
    element: <EditCashCenter />,
    isPrivate: 1,
  },
  {
    path: Paths.consumable,
    element: <ConsumablesList />,
    isPrivate: 1,
  },
  {
    path: Paths.addConsumable,
    element: <AddConsumable />,
    isPrivate: 1,
  },
  {
    path: `${Paths.consumableDetails}/:consumableId`,
    element: <ConsumableDetails />,
    isPrivate: 1,
  },
  {
    path: `${Paths.editConsumable}/:consumableId`,
    element: <EditConsumable />,
    isPrivate: 1,
  },
  {
    path: Paths.consumableSummary,
    element: <ConsumableSummary />,
    isPrivate: 1,
  },
  {
    path: Paths.notification,
    element: <NotificationList />,
    isPrivate: 1,
  },
  {
    path: Paths.addNotification,
    element: <AddNotification />,
    isPrivate: 1,
  },
  {
    path: `${Paths.notificationDetails}/:notificationId`,
    element: <NotificationDetails />,
    isPrivate: 1,
  },
  {
    path: `${Paths.editNotification}/:notificationId`,
    element: <EditNotification />,
    isPrivate: 1,
  },
  {
    path: Paths.escalationMatrix,
    element: <EscalationMatrixList />,
    isPrivate: 1,
  },
  {
    path: Paths.addEscalationMatrix,
    element: <AddEscalationMatrix />,
    isPrivate: 1,
  },
  {
    path: `${Paths.editEscalationMatrix}/:id`,
    element: <EditEscalationMatrix />,
    isPrivate: 1,
  },
  {
    path: Paths.ticketsList,
    element: <TicketsList />,
    isPrivate: 1,
  },
  {
    path: Paths.routesList,
    element: <RoutesList />,
    isPrivate: 1,
  },
  {
    path: Paths.addRoute,
    element: <AddRoute />,
    isPrivate: 1,
  },
  {
    path: Paths.profile,
    element: <Profile />,
    isPrivate: 1,
  },
  {
    path: Paths.changePassword,
    element: <ChangePassword />,
    isPrivate: 1,
  },
  {
    path: Paths.vehiclesList,
    element: <VehiclesList />,
    isPrivate: 1,
  },
  {
    path: Paths.addVehicles,
    element: <AddVehicle />,
    isPrivate: 1,
  },
  {
    path: `${Paths.editVehicle}/:vehicleId`,
    element: <UpdateVehicle />,
    isPrivate: 1,
  },
  {
    path: `${Paths.vehicleDetails}/:vehicleId`,
    element: <VehicleDetails />,
    isPrivate: 1,
  },
  {
    path: Paths.currency,
    element: <CurrencyList />,
    isPrivate: 1,
  },
  {
    path: Paths.currencyAdd,
    element: <AddCurrency />,
    isPrivate: 1,
  },
  {
    path: `${Paths.currencyDetails}/:currencyId`,
    element: <CurrencyDetails />,
    isPrivate: 1,
  },
  {
    path: `${Paths.currencyEdit}/:currencyId`,
    element: <EditCurrency />,
    isPrivate: 1,
  },
];

export default function AppRoutes() {
  const authCtx = useContext(AuthContext);
  // const {
  //   mutate: updateProfile,
  //   data: updateProfileRes,
  //   isPending: updatingProfile,
  //   // error: updateProfileError,
  //   reset: updateProfileReset,
  // } = useLogin();
  // useEffect(() => {
  //   if (updateProfileRes?.data) {
  //     const _data = updateProfileRes.data;
  //     authCtx.login(
  //       _data.accessToken,
  //       _data.accessTokenExpiry,
  //       _data.refreshToken,
  //       _data.refreshTokenExpiry
  //     );
  //   }
  // }, [updateProfileRes]);
  useEffect(() => {
    // updateProfile({ userName: "Admin", password: "Abc@123456" });
    if (window.self !== window.top) {
      window.addEventListener("message", messageHandler);
    } else {
      const sessionData = JSON.stringify({
        redirectUrl: window.location.pathname,
      });
      const encodedData = encodeURIComponent(sessionData);
      window.location.href = `${process.env.REACT_APP_ADMIN}/?sessionData=${encodedData}`;
    }
    return () => {
      window.removeEventListener("message", messageHandler);
    };
  }, []);

  const messageHandler = (event) => {
    if (event.origin === process.env.REACT_APP_ADMIN) {
      if (event.data.auth) {
        const _data = JSON.parse(event.data.auth);
        authCtx.login(
          _data.accessToken,
          _data.accessTokenExpiry,
          _data.refreshToken,
          _data.refreshTokenExpiry,
        );
      } else {
        // eslint-disable-next-line no-console
        console.log("Not authenticated");
      }
    }
  };
  return (
    <BrowserRouter>
      {authCtx.isLoggedIn ? (
        <>
          <RouteListener />
          <LicenseExpiryToast />
          {authCtx.isUserVerified ? (
            <>
              <Header />
              <IdleManager />
              <div className="content-container">
                <Routes>
                  {routes.map((route, index) => {
                    return (
                      <Route
                        key={index}
                        path={route.path}
                        element={route.element}
                      />
                    );
                  })}
                </Routes>
              </div>
            </>
          ) : (
            <Routes>
              <Route
                key="app-verification"
                path="/"
                element={<LoginAgreement />}
              />
              )
            </Routes>
          )}
        </>
      ) : (
        <Routes>
          <Route path="/" element={<>UnAuthorized</>} />
        </Routes>
      )}
    </BrowserRouter>
  );
}
